module.exports = __webpack_public_path__ + "static/media/group-45-copy-2.a43d28cc.svg";